import React, { useState } from "react";
import { Grid2 } from "@mui/material";
// Styling
import styles from "./SiteTypes.module.scss";
// Local imports
import {
  errorMessages,
  buttonText,
  reachedMaximum,
} from "../ConstantData/CreateSiteConstantData";
import CustomButton from "../../../../../../GlobalComponents/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";
import LicenceCard from "../LicenceCard/LicenceCard";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";

export default function SiteTypes(props) {
  const navigate = useNavigate();
  const {
    siteData,
    setShowType,
    flushStateVariables,
    selectedType,
    setSelectedType,
    cloneSiteData,
    blueprintData,
    selectedOrg,
    numSitesFeature,
    basePlan,
    orgId,
    additionalSite,
    isPartOfParentOrg,
    handleShowType,
  } = props;

  //popup
  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupButtonFunction: () => {},
    popupCancelFunction: () => {},
    popupCancelTitle: "",
  });

  const ActivatePopup = (type, message) => {
    if (type === "no_access") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "You don't have access, contact your admin",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
          navigate(`/account/${orgId}/dashboard`);
        },
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
      });
    }
  };

  const isParentOrg = selectedOrg?.parentOrgId;

  const isLimitReached =
    numSitesFeature != null &&
    numSitesFeature.limitOrAvailablity === numSitesFeature.used;

  const isEmpty = {
    "New Wordpress Site": isLimitReached,
    "Migrate Site": isLimitReached,
    "Clone Site": isLimitReached || cloneSiteData?.length === 0,
    "Blueprint Site": isLimitReached || blueprintData?.length === 0,
  };

  const getErrorMessage = (title) => {
    if (isLimitReached) {
      return reachedMaximum.title;
    }
    return errorMessages[title] || "";
  };

  // const getSubErrorMessage = (title) => {
  //   if (isLimitReached) {
  //     return reachedMaximum.subTitle;
  //   }
  //   return subHeaderMessages[title] || "";
  // };

  const getButton = (title) => {
    if (isLimitReached) {
      return reachedMaximum.button;
    }
    return buttonText[title] || "";
  };

  const handleSelectType = (item) => {
    if (orgId > 0 && !isPartOfParentOrg) {
      ActivatePopup("no_access");
      return;
    }
    if (isEmpty[item.title]) {
      setSelectedType(item.title);
    } else {
      setShowType(item);
      flushStateVariables();
    }
  };

  const isExpanded = (title) => {
    return isLimitReached || (selectedType === title && isEmpty[title]);
  };

  const handleButtonClick = (title) => {
    let path = "";
    if (isLimitReached) {
      path = `/account/${orgId}/modify-plan`;
    } else if (title === "New Wordpress Site") {
      path = `/account/${orgId}/modify-plan`;
    } else if (title === "Blueprint Site") {
      path = `/account/${orgId}/blueprints`;
    }
    if (path) {
      navigate(path);
    }
  };

  return (
    <>
      <Grid2 className={styles.siteTypesContainer}>
        <Grid2>
          <LicenceCard
            basePlan={basePlan}
            numSitesFeature={numSitesFeature}
            orgId={orgId}
            additionalSite={additionalSite}
            isParentOrg={isParentOrg}
          />
        </Grid2>
        <Grid2 className={styles.siteTypes}>
          {siteData?.map(({ icon: Icon, title, description }, index) => (
            <Grid2
              key={index}
              className={styles.Container}
              onClick={() =>
                handleSelectType({ title, description, icon: Icon })
              }
            >
              <Grid2
                className={`${styles.ChooseflexBox} ${
                  isExpanded(title) ? styles.expanded : ""
                }`}
              >
                <Grid2 className={styles.headerFlexbox}>
                  <Grid2 className={styles.Icon}>
                    <Icon />
                  </Grid2>
                  <Grid2 className={styles.headerWidth}>
                    <Grid2 className={styles.header}>{title}</Grid2>
                    <Grid2 className={styles.subHeader}>{description}</Grid2>
                  </Grid2>
                </Grid2>
                {!isExpanded(title) ? (
                  <Grid2 className={styles.create}>Start Now</Grid2>
                ) : (
                  <Grid2 className={styles.buyPlanFlexBox}>
                    <Grid2>
                      <Grid2 className={styles.errorMessage}>
                        {getErrorMessage(title)}{" "}
                        {isLimitReached && (
                          <>
                            {numSitesFeature?.used}/
                            {numSitesFeature?.limitOrAvailablity}
                          </>
                        )}
                      </Grid2>
                      {/* <Grid2 className={styles.subHeader}>
                        {getSubErrorMessage(title)}
                      </Grid2> */}
                    </Grid2>
                    {(orgId === -1 || isParentOrg === null) && (
                      <Grid2 className={styles.button}>
                        <Grid2
                          className={styles.create}
                          onClick={() => handleButtonClick(title)}
                        >
                          {getButton(title)}
                        </Grid2>
                        {!isExpanded(title) ? (
                          <CustomButton className={styles.buyPlan}>
                            Buy Plan
                          </CustomButton>
                        ) : (
                          ""
                        )}
                      </Grid2>
                    )}
                  </Grid2>
                )}
              </Grid2>
            </Grid2>
          ))}
        </Grid2>
      </Grid2>
      <FormPopup
        trigger={popup.popupState}
        setTrigger={setPopup}
        type={popup.popupType}
        title={popup.popupTitle}
        subtitle={popup.popupSubtitle}
        button={popup.popupButton}
        cancel={popup.popupCancel}
        buttonTitle={popup.popupButtonTitle}
        buttonFunction={popup.popupButtonFunction}
        popupCancelFunction={popup.popupCancelFunction}
        cancelTitle={popup.popupCancelTitle}
        handover={true}
      />
    </>
  );
}
